module.exports = __webpack_public_path__ + "img/wind.edb8b936.png";